import React from 'react';
import classnames from 'classnames';

import styles from './AccountTable.module.css';
import { Asset, Debt } from '../../types/accounts';

import upIcon from '../../assets/Up.png';
import downIcon from '../../assets/Down.png';
import { ExchangeRates } from '../../types/exchangeRates';
import { convertValue } from '../../utils/convertValue';

type Account = Asset | Debt;

interface AccountTableProps {
  items: Account[];
  rates: ExchangeRates | null;
  type: 'Asset' | 'Debt';
  emptyMessage: string;
}

interface AccountTableRowProps {
  item: Account;
  type: 'Asset' | 'Debt';
  rate: number;
}

const AccountTableRow: React.FC<AccountTableRowProps> = ({
  item,
  rate,
  type,
}) => {
  return (
    <div className={styles.tableRow}>
      <img alt="pic" src={type === 'Asset' ? upIcon : downIcon} />
      <span>{item.name}</span>
      <span>{item.value}</span>
      <span>{item.currency}</span>
      <span>{rate.toFixed(2)}</span>
      <span
        className={classnames({
          [styles.asset]: type === 'Asset',
          [styles.debt]: type === 'Debt',
        })}
      >
        ${convertValue(item.value, rate).toFixed(2)}
      </span>
    </div>
  );
};

const AccountTable: React.FC<AccountTableProps> = ({
  items,
  rates,
  type,
  emptyMessage,
}) => {
  return (
    <div className={styles.table}>
      {items.length ? (
        <div className={styles.tableHeader}>
          <span>Name</span>
          <span>Amount</span>
          <span>Currency</span>
          <span>Rate</span>
          <span>$ Value</span>
        </div>
      ) : null}
      {items.length ? (
        <div className={styles.tableBody}>
          {items.map((item: Account, index: number) => (
            <AccountTableRow
              item={item}
              rate={rates ? rates[item.currency] : 0}
              type={type}
              key={index}
            />
          ))}
        </div>
      ) : (
        <span className={styles.tableEmpty}>{emptyMessage}</span>
      )}
    </div>
  );
};

export default AccountTable;
